import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="flex h-full items-center justify-center px-6 py-16">
      <div className="text-center space-y-3 max-w-md">
        <h1 className="text-4xl font-bold tracking-tight">404</h1>
        <p className="text-muted-foreground">Сторінку не знайдено.</p>
        <Button asChild>
          <a href={import.meta.env.BASE_URL}>На головну</a>
        </Button>
      </div>
    </div>
  );
}
